import { LinkType } from '@lemontaps/lib/types/api';
import {
  Box,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  styled,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  linkTypes: LinkType[];
  value: number | null;
  onChange: (value: number) => void;
  disabled?: boolean;
  genericWebsiteColor?: string;
  approvalRequiredLinkTypes?: string[];
};
export const LinkTypeSelector = ({
  linkTypes,
  onChange,
  value,
  disabled,
  genericWebsiteColor,
  approvalRequiredLinkTypes,
}: Props) => {
  const { t } = useTranslation();

  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel id='labelId'>{t('chooseLink')}</InputLabel>
      <Select
        value={value || ''}
        labelId={'labelId'}
        label={t('chooseLink')}
        onChange={({ target: { value } }) => onChange(value as number)}
      >
        <MenuItem value='' sx={{ display: 'none' }}>
          <ListItemText>{t('chooseLink')}</ListItemText>
        </MenuItem>
        {linkTypes.map(linkType => (
          <MenuItem key={linkType.id} value={linkType.id}>
            <Box display='flex' alignItems='center'>
              <IconWrapper
                sx={{
                  background: linkType.backgroundCss || genericWebsiteColor || '#152570',
                }}
              >
                <img src={linkType.iconUrl} alt={linkType.name} />
              </IconWrapper>
              <ListItemText>{linkType.name}</ListItemText>
              {approvalRequiredLinkTypes?.includes(linkType.uniqueId) && (
                <Typography
                  sx={{ ml: 1, opacity: 0.4, color: 'black' }}
                  variant='caption'
                  color='warning'
                >
                  {t('requiresApproval')}
                </Typography>
              )}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const IconWrapper = styled(Box)({
  padding: '0.6rem',
  marginRight: '0.8rem',
  borderRadius: '50%',
  width: '2.8rem',
  height: '2.8rem',
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
  },
});
